"use strict";

var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MerkleSumTree = exports.ProofStep = exports.Leaf = exports.Bucket = void 0;
var Base_1 = require("./Base");
var Bucket = function Bucket(size, hashed) {
  _classCallCheck(this, Bucket);
  this.size = BigInt(size);
  this.hashed = hashed;
  // each node in the tree can have a parent, and a left or right sibling
  this.parent = null;
  this.left = null;
  this.right = null;
};
exports.Bucket = Bucket;
var Leaf = /*#__PURE__*/function () {
  function Leaf(hashFn, rng, data) {
    _classCallCheck(this, Leaf);
    this.hashFn = hashFn;
    this.rng = rng.map(function (x) {
      return BigInt(x);
    });
    this.data = data;
  }
  _createClass(Leaf, [{
    key: "getBucket",
    value: function getBucket() {
      var hashed;
      if (this.data) {
        hashed = this.hashFn(this.data);
      } else {
        hashed = Buffer.alloc(32);
      }
      return new Bucket(BigInt(this.rng[1]) - BigInt(this.rng[0]), hashed);
    }
  }]);
  return Leaf;
}();
exports.Leaf = Leaf;
var ProofStep = function ProofStep(bucket, right) {
  _classCallCheck(this, ProofStep);
  this.bucket = bucket;
  this.right = right; // whether the bucket hash should be appeded on the right side in this step (default is left
};
exports.ProofStep = ProofStep;
var MerkleSumTree = /*#__PURE__*/function (_Base_1$Base) {
  _inherits(MerkleSumTree, _Base_1$Base);
  function MerkleSumTree(leaves, hashFn) {
    var _this;
    _classCallCheck(this, MerkleSumTree);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(MerkleSumTree).call(this));
    _this.leaves = leaves;
    _this.hashFn = hashFn;
    MerkleSumTree.checkConsecutive(leaves);
    _this.buckets = [];
    var _iterator = _createForOfIteratorHelper(leaves),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var l = _step.value;
        _this.buckets.push(l.getBucket());
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var buckets = [];
    var _iterator2 = _createForOfIteratorHelper(_this.buckets),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var bucket = _step2.value;
        buckets.push(bucket);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    while (buckets.length !== 1) {
      var newBuckets = [];
      while (buckets.length) {
        if (buckets.length >= 2) {
          var b1 = buckets.shift();
          var b2 = buckets.shift();
          var size = b1.size + b2.size;
          var hashed = _this.hashFn(Buffer.concat([_this.sizeToBuffer(b1.size), _this.bufferify(b1.hashed), _this.sizeToBuffer(b2.size), _this.bufferify(b2.hashed)]));
          var b = new Bucket(size, hashed);
          b2.parent = b;
          b1.parent = b2.parent;
          b1.right = b2;
          b2.left = b1;
          newBuckets.push(b);
        } else {
          newBuckets.push(buckets.shift());
        }
      }
      buckets = newBuckets;
    }
    _this.root = buckets[0];
    return _this;
  }
  _createClass(MerkleSumTree, [{
    key: "sizeToBuffer",
    value: function sizeToBuffer(size) {
      var buf = Buffer.alloc(8);
      var view = new DataView(buf.buffer);
      view.setBigInt64(0, BigInt(size), false); // true when little endian
      return buf;
    }
  }, {
    key: "getProof",
    // gets inclusion/exclusion proof of a bucket in the specified index
    value: function getProof(index) {
      var curr = this.buckets[Number(index)];
      var proof = [];
      while (curr && curr.parent) {
        var right = !!curr.right;
        var bucket = curr.right ? curr.right : curr.left;
        curr = curr.parent;
        proof.push(new ProofStep(bucket, right));
      }
      return proof;
    }
  }, {
    key: "sum",
    value: function sum(arr) {
      var total = BigInt(0);
      var _iterator3 = _createForOfIteratorHelper(arr),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var value = _step3.value;
          total += BigInt(value);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return total;
    } // validates the suppplied proof for a specified leaf according to the root bucket
  }, {
    key: "verifyProof",
    value: function verifyProof(root, leaf, proof) {
      var rng = [this.sum(proof.filter(function (x) {
        return !x.right;
      }).map(function (x) {
        return x.bucket.size;
      })), BigInt(root.size) - this.sum(proof.filter(function (x) {
        return x.right;
      }).map(function (x) {
        return x.bucket.size;
      }))];
      if (!(rng[0] === leaf.rng[0] && rng[1] === leaf.rng[1])) {
        // supplied steps are not routing to the range specified
        return false;
      }
      var curr = leaf.getBucket();
      var hashed;
      var _iterator4 = _createForOfIteratorHelper(proof),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var step = _step4.value;
          if (step.right) {
            hashed = this.hashFn(Buffer.concat([this.sizeToBuffer(curr.size), this.bufferify(curr.hashed), this.sizeToBuffer(step.bucket.size), this.bufferify(step.bucket.hashed)]));
          } else {
            hashed = this.hashFn(Buffer.concat([this.sizeToBuffer(step.bucket.size), this.bufferify(step.bucket.hashed), this.sizeToBuffer(curr.size), this.bufferify(curr.hashed)]));
          }
          curr = new Bucket(BigInt(curr.size) + BigInt(step.bucket.size), hashed);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return curr.size === root.size && curr.hashed.toString('hex') === root.hashed.toString('hex');
    }
  }], [{
    key: "checkConsecutive",
    value: function checkConsecutive(leaves) {
      var curr = BigInt(0);
      var _iterator5 = _createForOfIteratorHelper(leaves),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var leaf = _step5.value;
          if (leaf.rng[0] !== curr) {
            throw new Error('leaf ranges are invalid');
          }
          curr = BigInt(leaf.rng[1]);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }]);
  return MerkleSumTree;
}(Base_1.Base);
exports.MerkleSumTree = MerkleSumTree;
if (typeof window !== 'undefined') {
  ;
  window.MerkleSumTree = MerkleSumTree;
}
exports.default = MerkleSumTree;